(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tradevape-age-gate"] && !Shopify.designMode) return;
  try {
    
(() => {
  const key = 'tradevape-age-confirmed-v1';
  const initialise = () => {
    const gate = document.querySelector('[data-tv-age-gate]');
    if (!gate || gate.dataset.initialised) return;
    gate.dataset.initialised = 'true';
    let confirmed = false;
    try { confirmed = sessionStorage.getItem(key) === 'yes'; } catch {}
    if (confirmed) { gate.close(); return; }
    gate.removeAttribute('open');
    gate.showModal();
    const previousOverflow = document.documentElement.style.overflow;
    document.documentElement.style.overflow = 'hidden';
    gate.addEventListener('cancel', event => event.preventDefault());
    gate.querySelector('[data-tv-age-confirm]').addEventListener('click', () => {
      try { sessionStorage.setItem(key, 'yes'); } catch {}
      gate.close();
      document.documentElement.style.overflow = previousOverflow;
      document.querySelector('.tv-logo')?.focus();
    });
    gate.querySelector('[data-tv-age-reject]').addEventListener('click', () => {
      gate.querySelector('[data-tv-age-actions]').hidden = true;
      gate.querySelector('[data-tv-age-actions]').style.display = 'none';
      gate.querySelector('[data-tv-age-denied]').hidden = false;
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialise, { once: true });
  else initialise();
  document.addEventListener('shopify:section:load', initialise);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tradevape-bulk-order"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('tradevape-bulk'))customElements.define('tradevape-bulk',class extends HTMLElement{
connectedCallback(){if(this.bound)return;this.bound=true;this.form=this.querySelector('form');this.inputs=[...this.querySelectorAll('input[data-variant]')];this.status=this.querySelector('[data-status]');this.format=new Intl.NumberFormat(document.documentElement.lang,{style:'currency',currency:this.dataset.currency});this.addEventListener('click',event=>{const button=event.target.closest('button[data-step]');if(!button||button.disabled)return;const input=button.closest('.tv-quantity').querySelector('input');input.value=Math.max(0,Math.min(Number(input.max)||Infinity,(Number(input.value)||0)+Number(button.dataset.step)));input.dispatchEvent(new Event('input',{bubbles:true}));});this.addEventListener('input',()=>this.update());this.form.addEventListener('submit',event=>this.submit(event));this.update();}
update(){let count=0,total=0;for(const input of this.inputs){const q=Math.max(0,Number(input.value)||0);count+=q;total+=q*Number(input.closest('.tv-variant').dataset.price);}this.querySelector('[data-count]').textContent=count;this.querySelector('[data-total]').textContent=this.format.format(total/100);}
async submit(event){event.preventDefault();const items=[];for(const input of this.inputs){if(input.disabled)continue;const quantity=Number(input.value);const min=Number(input.dataset.ruleMin)||1,step=Number(input.dataset.ruleStep)||1;if(!Number.isSafeInteger(quantity)||quantity<0||(quantity>0&&(quantity<min||quantity%step!==0))||(input.max&&quantity>Number(input.max))){this.status.textContent=this.status.dataset.invalid;input.focus();return;}if(quantity>0)items.push({id:Number(input.dataset.variant),quantity});}if(!items.length){this.status.textContent=this.status.dataset.empty;return;}const button=this.querySelector('[data-submit]');button.disabled=true;this.status.textContent=this.status.dataset.working;try{const response=await fetch(this.dataset.add,{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({items})});const data=await response.json();if(!response.ok)throw new Error(data.description||this.status.dataset.error);location.assign(this.dataset.cart);}catch(error){this.status.textContent=error.message||this.status.dataset.error;button.disabled=false;}}
});

  } catch(e) { console.error(e); }
})();
})();
